import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { TemaCompite } from '@/components/tema/tema-compite';

/**
 * El contenedor de toda pantalla de Estrategias de Mercado dentro de Compite
 * (Decisiones, Revisar precios, Estrategia). El tema es el de Jordi para todo
 * Compite (spec 310: índigo del logo, Inter, radios D-5): `<TemaCompite>` lo
 * prende sólo acá adentro, y a los diálogos mientras la pantalla está montada.
 * Este marco sólo pone el ancho y el aire de la página.
 */
export function MarcoCompite({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <TemaCompite>
      <div
        className={cn(
          'mx-auto w-full max-w-[1480px] space-y-8 px-5 py-8 sm:px-8 lg:px-10',
          className
        )}
      >
        {children}
      </div>
    </TemaCompite>
  );
}
